import { c as _c } from "react/compiler-runtime";
import { Image } from "@opensea/next-ui-kit";
import { Chip, classNames, FlexColumn, Markdown, TextBody, TextHeading, TextOverflow } from "@opensea/ui-kit";
export function TeamModuleSlide(t0) {
  const $ = _c(20);
  const {
    name,
    imageUrl,
    title,
    bio,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = classNames("relative items-center gap-5 overflow-hidden", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== imageUrl) {
    t2 = imageUrl ? <Image alt="" className="rounded-full" height={256} objectFit="cover" sizes="auto" src={imageUrl} width={256} /> : null;
    $[2] = imageUrl;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <div className="relative w-full px-4.5">{t2}</div>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = name || "Name";
  let t5;
  if ($[6] !== t4) {
    t5 = <TextHeading size="md">{t4}</TextHeading>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== title) {
    t6 = title ? <Chip>{title}</Chip> : null;
    $[8] = title;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== bio) {
    t7 = bio ? <TextOverflow className="w-full items-center" lines={3}><TextBody asChild={true} className="!text-text-secondary mx-auto"><Markdown>{bio}</Markdown></TextBody></TextOverflow> : null;
    $[10] = bio;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t5 || $[13] !== t6 || $[14] !== t7) {
    t8 = <FlexColumn className="w-full items-center gap-2">{t5}{t6}{t7}</FlexColumn>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t1 || $[17] !== t3 || $[18] !== t8) {
    t9 = <FlexColumn className={t1}>{t3}{t8}</FlexColumn>;
    $[16] = t1;
    $[17] = t3;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
}